import PropTypes from "prop-types";
import { DatePicker } from "@mui/x-date-pickers";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";

export const CustomDatePicker = ({
  id,
  label,
  value,
  onChange,
  disabled,
  InputLabelProps,
  InputProps,
  helperText,
  error,
  maxDate,
  minDate,
  required,
  ...props
}) => {
  return (
    <FormControl
      fullWidth
      variant="standard"
      sx={{ pt: 3.5 }}
      error={error}
      disabled={disabled}
      {...props}
    >
      {label && (
        <InputLabel
          shrink
          disabled={disabled}
          required={required}
          sx={{
            fontSize: "0.875rem",
            lineHeight: "1.125rem",
            transform: "scale(1)",
          }}
          {...{ htmlFor: id }}
          {...InputLabelProps}
        >
          {label}
        </InputLabel>
      )}
      <DatePicker
        value={value}
        onChange={onChange}
        disabled={disabled}
        format="DD/MMM/YYYY"
        maxDate={maxDate}
        minDate={minDate}
        slotProps={{
          textField: {
            error: error,
            disabled: disabled,
            required: required,
          },
        }}
        {...InputProps}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

CustomDatePicker.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  InputLabelProps: PropTypes.object,
  InputProps: PropTypes.object,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  required: PropTypes.bool,
};
